module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 1
 ** module chunks = 0
 **/